import React from 'react'
import ClaimSectionBreadcrumb from './ClaimSectionBreadcrumb'
import Selectpicker from '../../shared/inputs/selectpicker'
import Datepicker from '../../shared/inputs/datepicker'
import SquareCheckbox from '../../shared/inputs/square_checkbox'
import ClaimPayloadForm from './ClaimPayloadForm'
import HelperTooltip from '../helper_tooltip'

const emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const phonePattern = /^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/;
const nineNumbersPattern = /^\d{9}$/

class ClaimSubmission extends React.Component {
  constructor(props) {
    super(props)

    const formMetaData = props.configuration || []
    const sectionLength = formMetaData.length
    const completedSections = props.completed_sections || []

    this.sectionGroupMapper = {
      ...formMetaData.reduce((accumulator, section) => {
        if (!accumulator[section.section_group]) {
          accumulator[section.section_group] = []
        }
        accumulator[String(section.section_group)].push(section.name)
        return accumulator
      }, {}),
      'Review and Submit': ['Review', 'Submit'],
      'Request Submitted': ['Submitted']
    }

    this.sectionGroups =
      formMetaData.map(section => section.section_group)
        .uniq()
        .concat(['Review and Submit', 'Request Submitted'])
    this.extraSections = [
      {
        name: 'Review',
        completed: props.issue_fields.length == 0,
        renderDiv: this.renderReviewSection.bind(this),
        index: sectionLength,
        errors: []
      },
      {
        name: 'Submit',
        completed: completedSections.indexOf('Submit') >= 0,
        renderDiv: this.renderSubmitTab.bind(this),
        index: sectionLength + 1
      },
      {
        name: 'Submitted',
        completed: completedSections.indexOf('Submit') >= 0,
        renderDiv: null,
        index: sectionLength + 2
      }
    ]
    const sections = this.buildSections(formMetaData, completedSections)
    this.state = {
      sections: sections,
      payload: {
        ...this.defaultPayload(formMetaData),
        ...this.props.claim_payload
      },
      currentSection: sections.filter(section => {
        return (!section.completed || section.name === 'Submit')
      })[0],
      formProperties: {
        editorMode: false,
        request: {},
        responseDetail: {}
      },
      issueFields: props.issue_fields || []
    }
  }

  buildSections(formMetaData, completedSections) {
    return formMetaData.map((section, index) => {
      return {
        name: section.name,
        completed: completedSections.indexOf(section.name) >= 0,
        rendersForm: true,
        index: index,
        errors: []
      }
    }).concat(this.extraSections)
  }

  defaultPayload(formMetaData) {
    return formMetaData.reduce((accumulator, section) => {
      return {
        ...accumulator,
        ...section.fields.filter(field => field.path || field.note).reduce((payload, field) => {
          let defaultValue = field.default || ''
          if (['number', 'decimal', 'integer'].indexOf(field.type) > -1) {
            defaultValue = defaultValue || 0
          }
          return {
            ...payload,
            [field.name]: defaultValue
          }
        }, accumulator)
      }
    }, {})
  }

  buildPayloadState(formMetaData) {
    let payload = {}
    formMetaData.map(section => {
      return section.fields.filter(field => field.path)
                    .map(field => {
                      return {
                        path: field.path,
                        default: field.default
                      }
                    })
                }).flatten()
                  .forEach((hashPath) => {
                    const keys = hashPath.path.split('/')
                    $.extend(true, payload, this.getNestedObject(keys, hashPath.default))
                  })
    return payload
  }

  buildNotesState(formMetaData) {
    return (
      formMetaData.map(section => {
                    return section.fields.filter(field => !field.path && field.note)
                  }).flatten()
                    .reduce((accumulator, field) => {
                      return {
                        ...accumulator,
                        ...{ [field.name]: field.default }
                      }
                    }, {})
    )
  }

  // ['a', 'b', 'c', 'd'] => {a: {b: c: {d: ''}}}
  getNestedObject(keys, child = '') {
    const key = keys.pop()
    let object = {[key]: child}
    if (keys.length > 0) {
      object = this.getNestedObject(keys, object)
    }
    return object
  }

  stateValueFor(field, stateValue) {
    if (!stateValue ) {
      stateValue = $.extend(true, {}, this.state.payload)
    }
    return stateValue[field.name]
  }

  // ['a', 'b', 'c', 'd'] => payload.a.b.c.d
  stateValueFromPayload(field, stateValue) {
    if (!field.path) { return }
    const keys = field.path.split('/')
    keys.forEach(key => stateValue = stateValue[key])
    return stateValue
  }

  sectionChangedHandler(currentSection) {
    this.setState({currentSection})
  }

  stateChangedHandler(field, value) {
    this.setState(prevState => {
      return {
        payload: {
          ...prevState.payload,
          [field.name]: value
        }
      }
    })
  }

  changeNotes(field, value) {
    this.setState(prevState => {
      const notes = { ...prevState.payload.notes, [field.name]: value }
      return {
        payload: { ...prevState.payload, notes: notes }
      }
    })
  }

  changePayload(field, value) {
    const keys = field.path.split('/')
    const stateJson = this.getNestedObject(keys, value)
    const payload = $.extend(true, {}, this.state.payload, stateJson)
    this.setState({payload})
  }

  formPropertiesChangedHandler(changedProperty) {
    this.setState(prevState => {
      return {
        formProperties: {
          ...prevState.formProperties,
          ...changedProperty
        }
      }
    })
  }

  buildSelectField(field) {
    return (
      <div className='selecpicker-wrapper'>
        <Selectpicker
          name={field.name}
          defaultValue={this.stateValueFor(field)}
          optionsForSelect={field.options}
          optionsForSelect={
            field.options.map(option =>
              option.constructor === Array ? option : [option, option]
            )
          }
          disabled={field.readonly}
          onChange={(value) => this.stateChangedHandler(field, value)}
          placeholder={field.placeholder}
        />
      </div>
    )
  }

  buildDateField(field) {
    return (
      <Datepicker
        name={field.name}
        format='yyyy-mm-dd'
        defaultValue={this.stateValueFor(field)}
        disabled={field.readonly}
        onChange={(value) => this.stateChangedHandler(field, value)}
        placeholder={gon.default_date_format_string}
        typeable={true}
        birthDate={field.type === 'birthdate'}
      />
    )
  }

  buildCheckboxField(field) {
    const checked = String(this.stateValueFor(field)) === 'true'
    return (
      <SquareCheckbox
        id={field.name}
        checked={checked}
        disabled={field.readonly}
        onChange={(checkedState) => this.stateChangedHandler(field, String(checkedState))}
      />
    )
  }

  buildNumberField(field) {
    return (
      <input
        type='number'
        className='form-control'
        onChange={(e) => this.stateChangedHandler(field, e.target.value)}
        value={this.stateValueFor(field)}
        disabled={field.readonly}
        placeholder={field.placeholder}
      />
    )

  }

  buildTextField(field) {
    return (
      <input
        type='text'
        className='form-control'
        onChange={(e) => this.stateChangedHandler(field, e.target.value)}
        value={this.stateValueFor(field)}
        disabled={field.readonly}
        placeholder={field.placeholder}
      />
    )
  }

  buildEmailField(field) {
    return (
      <input
        type='email'
        className='form-control'
        onChange={(e) => this.stateChangedHandler(field, e.target.value)}
        value={this.stateValueFor(field)}
        disabled={field.readonly}
        placeholder={field.placeholder}
      />
    )
  }

  buildPasswordField(field) {
    return (
      <input
        autoComplete='new-password'
        type='password'
        className='form-control'
        onChange={(e) => this.stateChangedHandler(field, e.target.value)}
        value={this.stateValueFor(field)}
        disabled={field.readonly}
        placeholder={field.placeholder}
      />
    )
  }

  fieldWithName(name) {
    return (
      this.props.configuration.map(section => {
                                return section.fields
                              }).flatten()
                                .filter(field => {
                                  return field.name === name
                                })[0]
    )
  }

  handleAnd(andConditions){
    return andConditions.reduce((accumulator, condition) => {
      if(condition.and){
        return accumulator && this.handleAnd(condition.and)
      }
      if(condition.or){
        return accumulator && this.handleOr(condition.or)
      }
      return accumulator && this.checkDependentFieldValue(condition)
    }, true)
  }

  handleOr(orConditions) {
    return orConditions.reduce((accumulator, condition) => {
      if(condition.and){
        return accumulator || this.handleAnd(condition.and)
      } else if(condition.or){
        return accumulator || this.handleOr(condition.or)
      }
      return accumulator || this.checkDependentFieldValue(condition)
    }, false)
  }

  checkDependentFieldValue(fieldAttributeValue) {
    let dependentField = this.fieldWithName(fieldAttributeValue.name)
    let dependentFieldValue = null
    if (!dependentField) {
      return false
    }
    if (this.showField(dependentField)) {
      const valueMapper = dependentField.value_mapper
      if (valueMapper && $.isPlainObject(valueMapper) && !$.isEmptyObject(valueMapper)) {
        const key = this.stateValueFor(dependentField)
        dependentFieldValue = valueMapper[key] || key
      } else {
        dependentFieldValue = this.stateValueFor(dependentField)
      }
      if(fieldAttributeValue.operator == 'not equals') {
        return dependentFieldValue !== fieldAttributeValue.value
      } else {
        return dependentFieldValue === fieldAttributeValue.value
      }
    }
  }

  showField(field) {
    if (field.dependent) {
      if(field.dependent.and){
        return this.handleAnd(field.dependent.and)
      }

      if(field.dependent.or){
        return this.handleOr(field.dependent.or)
      }
      return this.checkDependentFieldValue(field.dependent)
    }
    return true
  }

  renderTooltipHelper(helperText) {
    if (helperText) {
      return <HelperTooltip helper_text={`<div>${helperText}</div>`} />
    }
  }

  renderFormField(field) {
    if (this.showField(field)) {
      let inputField = null
      if (field.type) {
        if (field.type === 'select') {
          inputField = this.buildSelectField(field)
        } else if (['date', 'birthdate'].indexOf(field.type) > -1) {
          inputField = this.buildDateField(field)
        } else if (field.type === 'checkbox') {
          inputField = this.buildCheckboxField(field)
        } else if (['number', 'decimal', 'integer'].indexOf(field.type) > -1) {
          inputField = this.buildNumberField(field)
        } else if (field.type === 'email') {
          inputField = this.buildEmailField(field)
        } else if (field.type === 'externalIdentificationType') {
          inputField = this.buildPasswordField(field)
        } else {
          inputField = this.buildTextField(field)
        }
      }
      const requiredSymbol = field.required ? '*' : ''
      const labelFontStyle = field.label_font || ''
      return (
        <div className='form-group' key={field.name}>
          <div className='label-wrapper'>
            <label className={`label-control ${labelFontStyle}`}>{`${field.label || ''} ${requiredSymbol}`} </label>
            { this.renderTooltipHelper(field.helper_text) }
          </div>
          <div className='input-field'>
            { inputField }
            { this.showErrorFor(field) }
          </div>
        </div>
      )
    }
  }

  showErrorFor(field) {
    const fieldErrors =
      this.state.currentSection.errors.reduce((accumulator, error) => {
        if (error.name === field.name) {
          accumulator = error.fieldErrors
        }
        return accumulator
      }, [])

    if (fieldErrors.length) {
      const errors =
        fieldErrors.map((error, index) => {
          return <li key={index} className='field-error'>{error}</li>
        })
      return (
        <ul className='field-errors'>
          { errors }
        </ul>
      )
    }
  }

  renderPayload() {
    const { payload } = this.state
    const showableFields =
      this.props.configuration.map(section => {
        return section.fields
      }).flatten()
        .reduce((accumulator, field) => {
          if ((field.path && !field.array) || field.note) {
            const value = this.stateValueFor(field)
            if (this.showField(field) && value !== undefined && String(value)) {
              accumulator.push(
                {
                  label: field.label,
                  value: String(value).toUpperCase()
                }
              )
            }
          } else if (field.label) {
            accumulator.push(
              {
                label: field.label
              }
            )
          }
          return accumulator
        }, [])
    return showableFields.map((field, index) => {
      return (
        <div key={index}>
          <label className='payload-review-label'>{field.label}</label>
          <span>{field.value}</span>
        </div>
      )
    })
  }

  renderSubmitForm() {
    const formMetaData = this.props.configuration || []

    const fields =
      formMetaData.map(section => {
        return section.fields
      }).flatten()
        .filter(field => this.showField(field))

    const mappedPayload =
      fields.reduce((accumulator, field) => {
        const selectedValue = this.stateValueFor(field)
        const mapper = field.value_mapper || {}
        const value = mapper[selectedValue] || selectedValue

        if (field.path) {
          const keys = field.path.split('/')
          return $.extend(true, accumulator, this.getNestedObject(keys, value))
        } else if (field.note) {
          return $.extend(true, accumulator, { notes: { [field.name]: value } })
        } else {
          return accumulator
        }
      }, {})

    const arrayFields = fields.filter(field => field.array)

    let statePayload =
      arrayFields.reduce((accumulator, field) => {
        const arrayValues =
          $.map(this.stateValueFromPayload(field, mappedPayload), (value, _key) => value)
        const keys = field.path.split('/')
        return $.extend(true, accumulator, this.getNestedObject(keys, arrayValues))
      }, $.extend(true, {}, mappedPayload))

    delete(statePayload.notes)
    let notes =
      fields.filter(field => field.note)
            .map(field => {
              return {
                path: field.note_path,
                name: field.name,
                value: this.stateValueFromPayload(field, mappedPayload) || mappedPayload.notes[field.name] || ''
              }
            })
            .flatten()
            .groupBy('path')

    $.map(notes, (groupedNotes, path) => {
      const noteValue =
        groupedNotes.reduce((accumulator, note) => {
          accumulator.push(`<b>${note.name}:</b> ${note.value}`)
          return accumulator
        }, []).join(`</br><br>`)
      return {
        path: path,
        value: `<!DOCTYPE html><html><body><br>${noteValue}</br></body></html>`
      }
    }).forEach((hashPath) => {
        const keys = hashPath.path.split('/')
        $.extend(true, statePayload, this.getNestedObject(keys, hashPath.value))
      })
    return (
      <ClaimPayloadForm
        id={this.props.id}
        payload={statePayload}
        onFormPropertiesChanged={this.formPropertiesChangedHandler.bind(this)}
        onSubmit={ (submitted) => this.setState({submitted}) }
        onPrevSection={ this.renderPrevSection.bind(this) }
        {...this.state.formProperties}
        isAdmin={this.props.is_admin}
        leaveScenario={this.props.leave_scenario}
        hrSubstitution={this.props.substitution_hr}
        requestRecipient={this.props.request_recipient}
        customizableScreenContent={this.props.customizable_screen_content}
        claimSubmissionAllowed={this.props.claim_submission_allowed}
        submissionDisabledDescription={this.props.submission_disabled_text}
      />
    )
  }

  renderSubmittedStatus() {
    return (
      <div className='submitted-status'>
        <div className='regard'>
          Thank you!
        </div>
        <div className='submitted-message'>
          <div>
            Your event was submitted successfully.
          </div>
          <br />
          <div>
            {`Please call ${this.props.request_recipient} for any questions you have about your claim or leave.`}
          </div>
        </div>
      </div>
    )
  }

  renderSubmitTab() {
    let submitContent = this.renderSubmitForm()
    if (this.state.submitted) {
      submitContent = this.renderSubmittedStatus()
    }
    return (
      <div className='claim-submit-tab'>
        {submitContent}
      </div>
    )
  }

  fieldsFor(currentSection) {
    const formMetaData = this.props.configuration
    return formMetaData.reduce((accumulator, section) => {
      if (section.name === currentSection.name) {
        accumulator = section.fields.filter(field => {
          return ((field.path && !field.array) || field.note) && this.showField(field)
        })
      }
      return accumulator
    }, [])
  }

  validForm() {
    const fields = this.fieldsFor(this.state.currentSection)
    const errors = fields.reduce((accumulator, field) => {
      let fieldErrors = []
      if (this.invalidForRequired(field)) {
        fieldErrors.push('This field is required.')
      }
      if (field.type === 'select') {
        fieldErrors = [...fieldErrors, ...this.errorsForSelectField(field)]
      } else if (['date', 'birthdate'].indexOf(field.type) > -1) {
        fieldErrors = [...fieldErrors, ...this.errorsForDateField(field)]
      } else if (['number', 'decimal', 'integer'].indexOf(field.type) > -1) {
        fieldErrors = [...fieldErrors, ...this.errorsForNumberField(field)]
      } else if (field.type === 'text') {
        fieldErrors = [...fieldErrors, ...this.errorsForTextField(field)]
      } else if (field.type === 'email') {
        fieldErrors = [...fieldErrors, ...this.errorsForEmailField(field)]
      } else if (field.type === 'phone') {
        fieldErrors = [...fieldErrors, ...this.errorsForPhoneField(field)]
      } else if (field.type === 'externalIdentificationType') {
        fieldErrors = [...fieldErrors, ...this.errorsForExternalIdentificationType(field)]
      }
      if (fieldErrors.length) {
        accumulator.push(
          {
            name: field.name,
            fieldErrors: fieldErrors
          }
        )
      }
      return accumulator
    }, [])
    this.setFormErrors(errors)
    return (errors.length === 0)
  }

  setFormErrors(errors) {
    this.setState(prevState => {
      return {
        currentSection: {
          ...prevState.currentSection,
          errors: errors
        }
      }
    })
  }

  errorsForSelectField(field) {
    const value = this.stateValueFor(field)
    let errors = []
    const isValid = field.options.filter(option => option[1] === value).length >= 0
    if (value && !isValid) {
      errors.push('Please select a value from list.')
    }
    return errors
  }

  errorsForDateField(field) {
    const value = this.stateValueFor(field)
    let errors = []
    if (value && String(value).trim() && !moment(value, 'YYYY-MM-DD', true).isValid()) {
      errors.push(`Please provide a valid date. Date must be in format ${gon.default_date_format_string}.`)
    } else if (value && field.type === 'birthdate') {
      let birthDateEndDate = new Date()
      birthDateEndDate.setFullYear(birthDateEndDate.getFullYear() - 1)
      const birthValue = new Date(value)
      if (birthValue.greater_than(birthDateEndDate)) {
        errors.push('Birthdate should be at least one year in the past.')
      }
    }
    return errors
  }

  errorsForNumberField(field) {
    const value = this.stateValueFor(field)
    const type = field.type
    let errors = []
    const numberValue = Number(value)
    const validNumber = numberValue >= 0 || numberValue < 0
    if (validNumber) {
      if (type === 'integer' && parseInt(numberValue) !== numberValue) {
        errors.push('Please provide a valid integer.')
      }
    } else {
      errors.push('Please provide a valid number.')
    }
    return errors
  }

  errorsForPhoneField(field) {
    const value = this.stateValueFor(field)
    let errors = []
    if (value && String(value).trim() && !phonePattern.test(value)) {
      errors.push('Enter valid phone number')
    }
    return errors
  }

  errorsForEmailField(field) {
    const value = this.stateValueFor(field)
    let errors = []
    if (value && String(value).trim() && !emailPattern.test(String(value).toLowerCase())) {
      errors.push('Please provide valid email address')
    }
    return errors
  }

  errorsForExternalIdentificationType(field) {
    const value = this.stateValueFor(field)
    let errors = []
    if (value && String(value).trim() && !nineNumbersPattern.test(value)) {
      errors.push('Please provide a 9 digit number without dashes')
    }
    return errors
  }

  errorsForTextField(field) {
    const value = this.stateValueFor(field)
    let errors = []
    if (value && String(value).trim() && String(value).length > 255) {
      errors.push('Text cannot be greater than 255 characters.')
    }
    return errors
  }

  invalidForRequired(field) {
    if (field.required) {
      const value = this.stateValueFor(field)
      return (value === null || value === undefined || !String(value))
    }
    return false
  }

  renderNextSection() {
    if (this.validForm()) {
      const sectionState = (fixSectionFields) => {
        this.setState(prevState => {
          const currentSectionIndex = prevState.currentSection.index
          let nextSectionIndex = currentSectionIndex + 1
          if (prevState.currentSection.name === 'Review' && fixSectionFields.length > 0) {
            nextSectionIndex -= 1
          } else if (nextSectionIndex === this.props.configuration.length && fixSectionFields.length == 0) {
            nextSectionIndex += 1
          }
          return {
            sections: prevState.sections.map(section => {
              if (section.name === prevState.currentSection.name) {
                section.completed = true
              }
              return section
            }),
            currentSection: prevState.sections[nextSectionIndex],
            issueFields: fixSectionFields
          }
        })
      }
      this.savePayload({ action: 'completed', name: this.state.currentSection.name, sectionState: sectionState })
    }
  }

  renderPrevSection() {
    const section = this.state.sections[this.state.currentSection.index - 1]
    const sectionState = (fixSectionFields) => {
      this.setState(prevState => {
        const currentSectionIndex = prevState.currentSection.index - 1
        let previousSectionIndex = currentSectionIndex
        if (previousSectionIndex === this.props.configuration.length) {
          previousSectionIndex = currentSectionIndex - 1
        }
        const previousSection = prevState.sections[previousSectionIndex]
        return {
          sections: prevState.sections.map(section => {
            if (section.name === previousSection.name) {
              section.completed = false
            }
            return section
          }),
          currentSection: previousSection
        }
      })
    }
    this.savePayload({ name: section.name, sectionState: sectionState })
  }

  savePayload(sectionDetail) {
    const params = {
      payload: this.state.payload,
      section: sectionDetail.name,
      completed: sectionDetail.action === 'completed'
    }
    $.ajax({
      url: `/claims/${this.props.id}`,
      method: 'PUT',
      data: params,
      success: (response) => {
        if (response.success) {
          sectionDetail.sectionState(response.fix_section_fields)
        } else {
          if (response.errors.form_errors) {
            this.setFormErrors(response.errors.form_errors)
          }
        }
      }
    })
  }

  renderReviewField(issue, index) {
    const fields = issue.fields
    return (
      <div className='review-field-div'>
        <p>{`Issue ${index + 1}`}</p>
        {this.renderFormField(fields[0])}
        <p className='fix-error-text'>{`Should be ${issue.issue}`}</p>
        {this.renderFormField(fields[1])}
      </div>
    )
  }

  renderReviewSection() {
    const issues = this.state.issueFields
    return (
      <div className='review-section'>
        <div className='review-section-text'>
          {`The following are issues that we have found with your submission. You can fix them below.`}
        </div>
        { issues.map((issue, index) => this.renderReviewField(issue, index)) }
      </div>
    )
  }

  renderSectionalForm(currentSection) {
    let content = null
    let nextButton = null
    let backButton = (<div />)
    let buttonText = currentSection.name === 'Review' ? 'Fix Issue' : 'Save & Continue'
    if (currentSection.rendersForm) {
      const formMetaData = this.props.configuration
      const fields = formMetaData.reduce((accumulator, section) => {
        if (section.name === currentSection.name) {
          accumulator = section.fields.filter(field => !field.hidden)
        }
        return accumulator
      }, [])
      content = fields.map(field => this.renderFormField(field))
    } else {
      content = currentSection.renderDiv()
    }
    if (currentSection.name !== 'Submit') {
      nextButton = (
        <button
          className='btn btn-success next-section'
          onClick={this.renderNextSection.bind(this)}
        >
          {buttonText}
        </button>
      )
    }
    if (currentSection.index !== 0 && currentSection.name !== 'Submit') {
      backButton = (
        <span
          className='prev-section'
          onClick={this.renderPrevSection.bind(this)}
        >
          Go Back
        </span>
      )
    }
    return (
      <div>
        { content }
        <div className='buttons'>
          { nextButton }
          { backButton }
        </div>
      </div>
    )
  }

  renderSection(index, sectionGroupName) {
    const sectionNames = this.sectionGroupMapper[sectionGroupName]
    const sections = this.state.sections.filter(section => {
      return sectionNames.indexOf(section.name) >= 0
    })
    const sectionGroupCompleted = sections.reduce((accumulator, section) => accumulator && section.completed, true)
    const activeSectionGroup = sectionNames.indexOf(this.state.currentSection.name) >= 0
    const completedClass = sectionGroupCompleted ? 'completed' : ''
    const activeClass = activeSectionGroup ? 'active' : ''
    return (
      <ClaimSectionBreadcrumb
        key={index}
        sectionGroupName={sectionGroupName}
        completedClass={completedClass}
        activeClass={activeClass}
        index={index}
      />
    )
  }

  render() {
    return (
      <div>
        <div className='header-div'>
          <h3 className='claim-submission-header'>
            Prepare your Request
          </h3>
          <span>
            {
              `In only few steps you can file your request with ${this.props.request_recipient} right from LeaveLogic. Please review and update the following information to submit your request and start your eligibility determination.`
            }
          </span>
        </div>
        <div className='claim-information-div'>
          <div className='image-div'>
            <div className='claim-image' style={{ backgroundImage: `url(${this.props.logo_url})` }} />
          </div>
          <div className='claim-name'>
            { this.props.name }
          </div>
        </div>
        <div className='claim-sections-breadcrumb'>
          {
            this.sectionGroups.map((sectionGroupName, index) => this.renderSection(index, sectionGroupName,))
          }
        </div>
        * indicates required field
        <div className='claim-sectional-form'>
          { this.renderSectionalForm(this.state.currentSection) }
        </div>
      </div>
    )
  }
}

export default ClaimSubmission;
